import { useFormField } from '@american-autonomy/ag-ui';

import Toggle from 'components/Toggle';
import WithField from 'components/WithField';

import useTranslation from './hooks/useTranslation';

import { EVENT_TYPE_ORDER, NO_SELECTION_INDEX, TEST_ID } from './constants';
import type { FieldValues, Props } from './types';

const EventTypeField = <T extends FieldValues>(props: Props<T>) => {
    const { className = '', control, isPlain, isRequired, name, testId = TEST_ID } = props;

    const { EVENT_TYPE_FIELD_LABEL, EVENT_TYPE_IS_REQUIRED, EVENT_TYPE_LABELS } = useTranslation();

    const {
        field: { onChange, value }
    } = useFormField({
        control,
        name,
        rules: {
            required: isRequired ? EVENT_TYPE_IS_REQUIRED : false
        }
    });

    const options = EVENT_TYPE_ORDER.map(eventType => ({
        label: EVENT_TYPE_LABELS[eventType],
        value: eventType
    }));

    const selectedIndex = options.findIndex(option => option.value === value);

    const activeIndex = selectedIndex === NO_SELECTION_INDEX ? undefined : selectedIndex;

    return (
        <WithField
            className={className}
            isPlain={isPlain}
            isRequired={isRequired}
            label={EVENT_TYPE_FIELD_LABEL}
            testId={testId}>
            <Toggle activeIndex={activeIndex} onClick={onChange} options={options} />
        </WithField>
    );
};

export default EventTypeField;
